import actions from './actions';

const initState = {
  apps: null,
  roles: null,
  schools: null,
  students: null,
  grades: null,
  users: null,
  key: null,
};

export default function appVersionReducer(state = initState, action) {
  switch (action.type) {
    case actions.FETCH_APPS_SUCCESS:
      return {
        ...state,
        apps: action.apps,
      };
    case actions.FETCH_APP_USERS_SUCCESS:
      return {
        ...state,
        users: action.users,
      };
    case actions.FETCH_APP_CONFIGS_SUCCESS:
      return {
        ...state,
        roles: action.roles,
        schools: action.schools,
        grades: action.grades,
        students: action.students,
      };
    case actions.SET_FILTER:
      return {
        ...state,
        key: action.key,
      };
    case actions.RESET:
      return {
        ...state,
        apps: null,
      };
    default:
      return state;
  }
}
